import React, { useState } from 'react';
import { Input } from '../Input';
import { IconButton } from '../IconButton';
import { Eye, EyeOff } from '../../../icons';
import { PasswordInputProps } from './types';

export const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ showToggle = true, disabled, ...props }, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    const handleTogglePassword = (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      setShowPassword((prev) => !prev);
    };

    const endAdornment = showToggle ? (
      <IconButton
        variant="default"
        size="md"
        onClick={handleTogglePassword}
        disabled={disabled}
        aria-label={showPassword ? 'Hide password' : 'Show password'}
      >
        {showPassword ? <EyeOff /> : <Eye />}
      </IconButton>
    ) : undefined;

    return (
      <Input
        ref={ref}
        type={showPassword ? 'text' : 'password'}
        autoComplete="current-password"
        endAdornment={endAdornment}
        disabled={disabled}
        {...props}
      />
    );
  }
);

PasswordInput.displayName = 'PasswordInput';

export type { PasswordInputProps } from './types';
